/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../../../src/app/components/error/root.component';
import * as i2 from '../../../../../src/app/providers/auth.service';
import * as i3 from '@angular/router';
const styles_RootComponent:any[] = ([] as any[]);
export const RenderType_RootComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_RootComponent,data:{}});
export function View_RootComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,([] as any[]),(null as any),(null as any));
}
export function View_RootComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'ng-component',
      ([] as any[]),(null as any),(null as any),(null as any),View_RootComponent_0,
      RenderType_RootComponent)),i0.ɵdid(49152,(null as any),0,i1.RootComponent,[i2.AuthService,
      i3.Router],(null as any),(null as any))],(null as any),(null as any));
}
export const RootComponentNgFactory:i0.ComponentFactory<i1.RootComponent> = i0.ɵccf('ng-component',
    i1.RootComponent,View_RootComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9jb21wb25lbnRzL2Vycm9yL3Jvb3QuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9jb21wb25lbnRzL2Vycm9yL3Jvb3QuY29tcG9uZW50LnRzIiwibmc6Ly8vaG9tZS9ub2RlL2FwcC9zcmMvYXBwL2NvbXBvbmVudHMvZXJyb3Ivcm9vdC5jb21wb25lbnQudHMuUm9vdENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxuZy1jb21wb25lbnQ+PC9uZy1jb21wb25lbnQ+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBOzhCQUFBLFVBQUE7ZUFBQTs7OyJ9



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./compiled/src/app/components/error/root.component.ngfactory.ts